import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const GetInvolvedPage = lazy(() => import('../pages/get-involved/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const DonationPage = lazy(() => import('../pages/donation/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about-us',
    element: <AboutPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/get-involved',
    element: <GetInvolvedPage />,
  },
  {
    path: '/donate',
    element: <DonationPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
